<template>
  <div class="addressee">
    <el-button plain style="padding:5px;margin-right:6px" size="mini" icon="el-icon-plus" @click="handleUserChoose" v-if="!disabled"></el-button>
    <template v-for="(item,index) in address" >
      <el-input
        :ref="`currentMail-${index}`"
        v-if="item.isEdit&&item.id===0"
        v-model="currentMail"
        :key="index"
        @keydown.enter.native="$refs[`currentMail-${index}`][0].$refs.input.blur()"
        @blur="handleCurrentBlur(item)">
      </el-input>
      <el-button-group v-else :key="index">
        <el-tooltip effect="dark" :content="item.mail" placement="top" :disabled="item.id!==0">
          <el-button class="name-button" size="mini" type="primary">{{item.name}}</el-button>
        </el-tooltip>
        <el-button class="tool-button" size="mini" type="primary" icon="el-icon-close" v-if="item.id!==0" @click="handleDelete(item)" :disabled="disabled"></el-button>
        <el-button v-else class="tool-button" size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(item,`currentMail-${index}`)"></el-button>
      </el-button-group>
    </template>
    <el-input 
      ref="mail"
      v-if="!disabled"
      v-model="mail"
      @keydown.enter.native="$refs['mail'].$refs.input.blur()" 
      @blur="handleDone">
    </el-input>
    <!-- 选择用户 -->
    <user-choose
      ref="userChoose"
      chooseType="checkBox"
      :dataListTitle="$t('mail.user')"
      :userChooseTitle="$t('mail.selectUser')"
      :userChooseVisible="userChooseVisible"
      @userChooseClose="userChooseVisible = false"
      @userChooseSave="saveChooseUser">
    </user-choose>
  </div>
</template>
<script>
import UserChoose from '@/components/UserChoose/index.vue'
import { validateMail } from '@/utils/validate'
export default {
  name: 'Addressee',
  components: {
    UserChoose
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    address: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      userChooseVisible: false,
      currentMail: '',
      mail: ''
    }
  },
  methods: {
    saveChooseUser(val) {
      console.log(val)
      val.forEach(v => {
        if (!this.address.find(a => a.id && (a.id === v.id))) {
          this.address.push(v)
        }
      })

      this.userChooseVisible = false
    },
    // 选择用户
    handleUserChoose() {
      this.userChooseVisible = true
      this.$refs['userChoose'].$emit('resetDialogChoose', this.address.map(r => { return r.id }))
    },
    handleDelete(item) {
      this.address.splice(this.address.indexOf(item), 1)
    },
    handleCurrentBlur(item) {
      if (this.currentMail === '') {
        this.address.splice(this.address.indexOf(item), 1)
      } else {
        if (!validateMail(this.currentMail)) return this.$message.error('不是有效的邮箱地址！')
        item.mail = this.currentMail
        item.name = this.currentMail.split('@')[0]
      }
      item.isEdit = false
      this.currentMail = ''
    },
    handleEdit(item, ref) {
      item.isEdit = true
      this.currentMail = item.mail
      this.$nextTick(_ => {
        this.$refs[ref][0].$refs.input.focus()
      })
    },
    handleDone() {
      if (this.mail !== '') {
        if (!validateMail(this.mail)) return this.$message.error('不是有效的邮箱地址！')
        this.address.push({
          name: this.mail.split('@')[0],
          mail: this.mail,
          id: 0,
          isEdit: false
        })
        this.mail = ''
      }
    }
  }
}
</script>
<style lang="scss">
.addressee{
  .el-button-group{
    margin-right: 8px;
    .name-button{
      padding:5px 15px;
      background-color: #d9ecff;
      color:black;
      border:unset;
      margin-right: 1px !important;
      &:hover{
        border:unset;
      }
    }
    .tool-button{
      background-color: #d9ecff;
      padding:5px 7px;
      color:black;
      border:unset;
      &:hover{
        border:unset;
      }
    }
  }
  .el-input{
    width: 150px;
    margin-right: 8px;
    .el-input__inner{
      border:none;
    }
  }
}
  
</style>